import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/api-flow.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-241b4cf8")

_pushScopeId("data-v-241b4cf8")
const _hoisted_1 = { class: "dt-open-api-api-flow" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "API接入说明", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("strong", null, "API接入流程")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "api-flow-title" }, "完整的API接入规范流程如下图所示：", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "api-flow-img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("strong", null, "1、申请应用")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "开发者调用开放平台接口之前预先申请应用，获取到相对应的APPID和APPSECRET，应用审核通过后方可调用平台接口。 ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("strong", null, "2、调用说明 ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "part-p" }, "2.1、请求方式 ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "平台目前提供的接口支持GET、POST方法，具体请看接口详情。", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "2.2、参数说明 ", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "必要参数：appId(应用id)、timestamp(当前时间戳毫秒)、sign(签名)、version(接口版本号目前1.0) ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "签名sign值构造：", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "所有参数按照参数名ASCII码值从小到大排序(字典序) 拼接成K1=V1&K2=V2&K3=V3SECRET的方式进行MD5加密生成签名 ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, "参数的值为空(包括null和\"\")及sign参数不参与签名。 ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "part-p" }, "2.3、签名方法 ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("pre", { class: "brush: java;" }, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createVNode("code", { class: "language-java" }, "\r\n/**\r\n * MD5加密\r\n *\r\n * @param str 加密字符串\r\n * @return\r\n */\r\n public static String MD5(String str) {\r\n        char[] hexDigits = {'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'};\r\n        try {\r\n            byte[] bytes = str.getBytes();\r\n            MessageDigest mdInst = MessageDigest.getInstance(\"MD5\");\r\n            mdInst.update(bytes);\r\n            byte[] mdBytes = mdInst.digest();\r\n            int length = mdBytes.length;\r\n            char[] chars = new char[length * 2];\r\n            int k = 0;\r\n            for (byte byte0 : mdBytes) {\r\n                chars[k++] = hexDigits[byte0 >>> 4 & 0xf];\r\n                chars[k++] = hexDigits[byte0 & 0xf];\r\n            }\r\n            return new String(chars);\r\n        } catch (Exception e) {\r\n            e.printStackTrace();\r\n            return null;\r\n        }\r\n }\r\n\r\n/**\r\n * 签名\r\n * 所有参数按照参数名ASCII码值从小到大排序(字典序) 拼接成K1=V1&K2=V2&K3=V3SECRET的方式进行MD5加密生成签名\r\n * 如果参数的值为空不参与签名\r\n *\r\n * @param params 参数\r\n * @param secret app密钥\r\n * @return\r\n */\r\n public static String sign(Map<String, Object> params, String secret) {\r\n        List<String> keys = new ArrayList<>(params.keySet());\r\n        Collections.sort(keys);\r\n        StringBuilder sb = new StringBuilder();\r\n        for (String key : keys) {\r\n            Object value = params.get(key);\r\n            if (null != value && !\"\".equals(value.toString())) {\r\n                sb.append(key).append('=').append(value).append('&');\r\n            }\r\n        }\r\n        sb.setLength(sb.length() - 1);\r\n        return MD5(sb.toString() + secret);\r\n }\r\n"),
  /*#__PURE__*/_createTextVNode("\r\n")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "part-p" }, "2.4、请求头", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("pre", { class: "brush: java;" }, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createVNode("code", { class: "language-java" }, "\r\n// 无特殊说明，请求体类型默认如下\r\nContent-Type: application/x-www-form-urlencoded; charset=UTF-8\r\n        "),
  /*#__PURE__*/_createTextVNode("\r\n    ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "part-p" }, "2.5、调用示例", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("pre", { class: "brush: java;" }, [
  /*#__PURE__*/_createTextVNode("        "),
  /*#__PURE__*/_createVNode("code", { class: "language-java" }, "\r\nMap params = new HashMap<>();\r\nparams.put(\"id\", \"xxxxxxxxxxxxxxxxxxxx\");\r\nparams.put(\"timestamp\", System.currentTimeMillis());\r\nparams.put(\"appId\", \"xxxxxxxxxxxxxxxx\");\r\nparams.put(\"version\", \"1.0\");\r\nparams.put(\"sign\", MD5Util.sign(params, secret));\r\nString result = HttpUtil.httpPost(\"https://openapi.iclass30.com/user/getUserById\", params, new HashMap<>());\r\nSystem.out.println(result);\r\n        "),
  /*#__PURE__*/_createTextVNode("\r\n    ")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "end-text" }, "其它开发语言参考上面的调用文档开发", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    _hoisted_21,
    _hoisted_22
  ]))
})